export function buildGestoresJornadaReturnQuery() {
  return 'tab=jornada'
}

export function buildGestoresEquipeMemberUrl(
  memberId: string,
  opts?: { section?: 'feedback'; back?: string },
) {
  const params = new URLSearchParams()
  if (opts?.section) params.set('section', opts.section)
  if (opts?.back) params.set('back', opts.back)
  const qs = params.toString()
  return `/gestores/equipe/${memberId}${qs ? `?${qs}` : ''}`
}

export function parseGestoresEquipeSection(value: string | null): 'feedback' | null {
  return value === 'feedback' ? 'feedback' : null
}
